// Extend the Window interface to include Google Tag Manager's dataLayer
declare global {
    interface Window {
        dataLayer?: GoogleTagManagerEvent[];
    }
}

type GoogleTagManagerEvent = Record<string, unknown>;

const GTM_ID_ATTRIBUTE = "data-gtm-id";

export const loadGtm = (gtmId?: string): boolean => {
    if (!gtmId) {
        console.warn("GTM ID is not provided. GTM will not be loaded.");
        return false;
    }

    // Prevent duplicate GTM script
    if (document.querySelector(`script[${GTM_ID_ATTRIBUTE}="${gtmId}"]`)) {
        return true;
    }

    try {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        window.dataLayer.push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js",
        });

        const script = createGtmScript(gtmId);
        document.head.insertBefore(script, document.head.firstChild);

        // Prevent duplicate noscript
        if (!document.querySelector(`noscript[${GTM_ID_ATTRIBUTE}="${gtmId}"]`)) {
            const noscript = createGtmNoscript(gtmId);
            document.body.insertBefore(noscript, document.body.firstChild);
        }

        return true;
    } catch (error) {
        console.error("Failed to load GTM:", error);
        return false;
    }
};

const createGtmScript = (gtmId: string): HTMLScriptElement => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}&l=dataLayer`;
    script.setAttribute(GTM_ID_ATTRIBUTE, gtmId);
    return script;
};

const createGtmNoscript = (gtmId: string): HTMLElement => {
    const noscript = document.createElement("noscript");
    noscript.setAttribute(GTM_ID_ATTRIBUTE, gtmId);
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    return noscript;
};
